import {
  Component,
  ComponentRef,
  inject,
  Injector,
  Input,
  OnDestroy,
  Pipe,
  Type,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { DialogBaseComponent } from "../../../../base-admin-panel/dialog-base/dialog-base.component";
import { ExcelService } from "../../../../../../services/ExcelService";
import { ObjectZonesModel } from "../../../Models/ObjectViewModel";
import { Subscription } from "rxjs";
import { ObjectsService } from "../../../../../../services/objects.service";
import { TrendBindingHistoryComponent } from '../trend-binding-history/trend-binding-history.component';
import { DialogService } from '../../../../../../services/dialog.service';
import { CalibartionValue, ExportCalibartionValue, InputViewModel, TrendViewModel } from '../../../Models/TrendViewModel';
import { TrendIconViewModel } from "../../../../../../models/TrendIconViewModel";
import { CalibrationsImportService } from "../../../../../../services/calibrations-import.service";


@Pipe({
  name: "orderBySensorValue",
  standalone: false
})
export class CalibrationSortPipe {
  transform(array: CalibartionValue[], args: string): CalibartionValue[] {
    array.sort((a: CalibartionValue, b: CalibartionValue) => {
      if (a.RawValue < b.RawValue) return -1;
      else
        if (a.RawValue > b.RawValue) return 1;
        else return 0;
    });
    return array;
  }
}

@Component({
  selector: 'app-trend-dialog-base',
  templateUrl: './trend-dialog-base.component.html',
  styleUrls: ['./trend-dialog-base.component.css'],
  standalone: false
})
export class TrendDialogBaseComponent extends DialogBaseComponent<TrendViewModel> implements OnDestroy {

  @Input()
  public Inputs: InputViewModel[] = [];
  @Input()
  public Zones: ObjectZonesModel[] = [];

  public updated: any;
  public Icons: TrendIconViewModel[] = [];

  options: any = {
    floor: 0,
    ceil: 30
  };
  trendtype: string = "";
  private subscription: Subscription;
  protected objectsService: ObjectsService;
  protected dialogService: DialogService;

  @ViewChild("trendBindingDialog", { static: true, read: ViewContainerRef }) container;
  protected componentRef: ComponentRef<any>;
  private calibrationImportService: CalibrationsImportService = inject(CalibrationsImportService);
  constructor(protected injector: Injector) {
    super(injector);

    this.dialogId = "trendManagement";
    this.dialogService = injector.get(DialogService);

    this.subscription = this.calibrationImportService.onImported.subscribe(data => {
      this.model.CalibrationTable = data;
    })

    this.objectsService = injector.get(ObjectsService);

    this.objectsService.GetTrendIcons()
      .subscribe(icons => {
        this.Icons = icons;

        let blank = new TrendIconViewModel();
        blank.Url = "/assets/icons/blank.svg";
        this.Icons.splice(0, 0, blank);
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public Incomingfile(event) {
    let file = event.target.files[0];
    if (!file) return;
    this.calibrationImportService.Import(file);
  }


  public export() {
    this.calibrationImportService.Export(
      this.model.CalibrationTable.map(c => {
        let res = new ExportCalibartionValue();
        res.SensorValue = c.RawValue;
        res.TrendValue = c.Value;
        res.Title = c.Title;
        return res;
      })
    )
  }

  public addValue() {
    this.model.CalibrationTable.push(new CalibartionValue());
    // this.updated = new Date();
  }

  public removeValue(val) {
    let idx = this.model.CalibrationTable.indexOf(val);
    if (idx < 0) return;
    this.model.CalibrationTable.splice(idx, 1);
  }

  public onZoneChange(event: Event) {

  }

  public onInputChange(inpId: string) { }


  IsHidden: boolean = false;
  // NotifyTreshold: boolean = false;
  // NoDispatch: boolean = false;

  open(model: any, type: { new(): TrendViewModel } = undefined): void {
    super.open(model, type);

    //if (this.model.Flags.indexOf("POINTBYEVT") >= 0)
    //  this.ChangeOnEvent = true;

    if (this.model.Flags.indexOf("HIDDENINFO") >= 0)
      this.IsHidden = true;

    // if (this.model.Flags.indexOf("NORMSEVENT") >= 0)
    //   this.NotifyTreshold = true;

    // if (this.model.Flags.indexOf("NODISPATCH") >= 0)
    //   this.NoDispatch = true;

    this.trendtype = this.model.Flags.replace("POINTBYEVT", "")
      .replace("HIDDENINFO", "")
      .replace("NORMSEVENT", "")
      .replace("NODISPATCH", "")
      .replace(/  /g, " ").trim();
  }

  submit(): void {
    this.model.Flags = this.trendtype;

    if (this.IsHidden)
      this.model.Flags += " HIDDENINFO";


    // if (this.NoDispatch)
    //   this.model.Flags += " NODISPATCH";

    this.model.LowAlarm = (typeof (this.model.LowAlarm) != "undefined" && this.model.LowAlarm != null) ? this.model.LowAlarm : undefined;
    this.model.HighAlarm = (typeof (this.model.HighAlarm) != "undefined" && this.model.HighAlarm != null) ? this.model.HighAlarm : undefined;

    if (this.model.DataType == 1) {
      this.model.MinScale = 0;
      this.model.MaxScale = 1;
      this.model.Units = "";
    }

    if (this.model.MinScale != 0 || this.model.MaxScale != 0)
      this.model.Flags += " NORMSEVENT";

    if (this.model.IconId === 0)
      this.model.IconId = undefined;

    let value = this.checkRawValuesUnique();
    if (this.checkRawValuesUnique() != null) {
      this.toastr.error(this.translate.instant(value));
      return;
    }

    super.submit();
  }

  checkRawValuesUnique(): string | null {
    const EPS = 1e-6;
    const table = this.model?.CalibrationTable ?? [];

    // 0 — ok, 1 — invalid
    if (table.length === 1) {
      return 'Sensor calibration is invalid';
    }

    if (table.length === 0) {
      return null;
    }

    const rawValues: number[] = [];

    for (const row of table) {
      const raw = row.RawValue;
      const val = row.Value;

      const rawNum = Number(raw);
      const valNum = Number(val);

      if (
        raw === null || raw === undefined ||
        val === null || val === undefined ||
        !Number.isFinite(rawNum) ||
        !Number.isFinite(valNum)
      ) {
        return 'Sensor calibration is invalid';
      }

      // ❌ duplicate Raw value within tolerance
      for (const existing of rawValues) {
        if (Math.abs(existing - rawNum) < EPS) {
          return 'Sensor calibration is invalid';
        }
      }

      rawValues.push(rawNum);
    }

    return null; // validation passed
  }


  public openedTabName: string = "main";

  public openTab(name: string) {
    this.openedTabName = name;
  }

  public isSelected(name: string) {
    return name == this.openedTabName;
  }

  public openInputBinding() {
    this.componentRef = this.dialogService.open(this.container, TrendBindingHistoryComponent);
    this.componentRef.instance.Inputs = this.Inputs;
    this.componentRef.instance.open(this.model);
  }
}
